<template>
    <span
      class="pointer"
      :style="{
            opacity: (isLoad)?0.5:1
          }"
      @click="onChange"
    >
      <v-icon
        v-if="!isOk"
        :small="small"
        :color="color"
      >mdi-account-off</v-icon>
      <v-icon
        v-else
        :small="small"
        :color="color"
      >mdi-account</v-icon>
    </span>
</template>

<script>
export default {
  name: 'IsActive',
  props: {
    isOk: {
      type: Number,
      default: 0,
    },
    icon: {
      type: String,
      default: 'mdi-account',
    },
    color: {
      type: String,
      default: null,
    },
    updateRequest: {
      type: Function,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isLoad: this.loading,
    };
  },
  watch: {
    loading(newVal) {
      this.isLoad = newVal;
    },
  },
  methods: {
    onChange() {
      if (!this.isLoad) {
        this.updateValue(1 - this.isOk);
      }
    },
    updateValue(value) {
      this.$emit('updated', value);
      if (this.updateRequest) {
        this.isLoad = true;
        setTimeout(() => {
          this.updateRequest(value)
            .catch((error) => {
              this.$emit('updated', 1 - value);
              console.error(error);
            })
            .finally(() => {
              this.isLoad = false;
            });
        }, 0);
      }
    },
  },
};
</script>

<style scoped>

</style>
